import React, { useState, useEffect } from 'react'
import AppLayout from '../../../../components/layout/layout'
import GeneralDetail from './Screens/GeneralDetails/GeneralDetail'
import { classesEventStore } from 'state/classes/classesStore'
import { useLocation } from 'react-router-dom'
import { useGetEventById } from 'api/EventCreation/EventCreation'
import { forceRefetch } from 'helper/utility'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { EventResp } from 'types/event/events'
import Contact from './Screens/Step2/Contact'
import DaysAndHours from './Screens/Step3/DaysAndHours'
import ScheduleAndActivities from './Screens/Step4/ScheduleAndActivities'
import Costs from './Screens/Step5/Costs'
import ManageTickets from './Screens/Step6/Tickets/ManageTickets'
import AdditionalClassSettings from './Screens/Step7/AdditionalClassSettings'
import Settings from './Screens/Step8/Settings'

export type CreateClassesProps = {
  currentEvent: EventResp
  currentData?: any | null
}

const CreateClasses: React.FC<CreateClassesProps> = ({ currentData }) => {
  const queryClient = useQueryClient()
  const location = useLocation<{ id: string }>()
  const stepCounter = classesEventStore(store => store.stepCounter)
  const setStepCounter = classesEventStore(store => store.setStepCounter)
  const setClassesData = classesEventStore(store => store.setClassesData)
  const setRequiredDetails = classesEventStore(
    store => store.setRequiredDetails,
  )
  const [data, setData] = useState(currentData || {})
  // const id = location.state?.id
  const { id } = useParams<{ id: string }>()

  const {
    data: getEventData,
    isLoading: eventDataLoading,
    isFetching: eventDataFetching,
    refetch: eventDataRefetch,
  } = useGetEventById(id)

  useEffect(() => {
    if (id) {
      eventDataRefetch()
    }
  }, [])

  useEffect(() => {
    if (id) {
      setClassesData(getEventData)
      setRequiredDetails((getEventData as EventResp)?.requiredDetails)
    } else {
      forceRefetch('event-detail-by-id', queryClient)
    }
  }, [getEventData, id])

  const next = (childData: any) => {
    setData(childData)
    setStepCounter(stepCounter + 1)
    // if (stepCounter === 1) {
    //   setStepCounter(3)
    // } else {
    //   setStepCounter(stepCounter + 1)
    // }
  }

  const prev = () => {
    setStepCounter(stepCounter - 1)
  }

  return (
    <AppLayout id={id}>
      {stepCounter === 0 && (
        <div
          className="create-event-main-content-wapper w-100"
          style={{ padding: '0px 40px 0px 40px' }}
        >
          <GeneralDetail handleNext={next} />{' '}
        </div>
      )}
      {stepCounter === 1 && (
        <div className="w-100 create-event-main-wapper">
          <Contact handleNext={next} handleBack={prev} />
        </div>
      )}
      {stepCounter === 2 && (
        <div className="create-event-main-content-wapper w-100">
          <DaysAndHours handleNext={next} handleBack={prev} />{' '}
        </div>
      )}
      {stepCounter === 3 && (
        <div
          className="create-event-main-content-wapper w-100"
          style={{ padding: '0px 40px 0px 40px' }}
        >
          <ScheduleAndActivities handleNext={next} handleBack={prev} />
        </div>
      )}
      {stepCounter === 4 && (
        <div className="create-event-main-content-wapper w-100">
          <Costs handleNext={next} handleBack={prev} />
          {''}
        </div>
      )}
      {stepCounter === 5 && (
        <div className="create-event-main-content-wapper w-100">
          <ManageTickets handleNext={next} handleBack={prev} />
        </div>
      )}
      {stepCounter === 6 && (
        <div className="create-event-main-content-wapper w-100">
          <AdditionalClassSettings handleNext={next} handleBack={prev} />
        </div>
      )}
      {stepCounter === 7 && (
        <div className="create-event-main-content-wapper w-100">
          <Settings handleNext={next} handleBack={prev} />
        </div>
      )}
    </AppLayout>
  )
}
export default CreateClasses
